export default [
  // 创建客户
  {
    name: "CreateClientUser",
    url: "/client/user/create",
    method: "POST",
    mock: false,
  },
  // 获取客户列表
  {
    name: "GetClientUserList",
    url: "/client/user/list",
    method: "GET",
    mock: false,
  },
  // 获取客户详情
  {
    name: "GetClientUserDetail",
    url: "/client/user/get",
    method: "GET",
    mock: false,
  },
  {
    name: "GetIbUserDetail",
    url: "/ib/user/get",
    method: "GET",
    mock: false,
  },
  // 保存客户详情
  {
    name: "SaveClientUser",
    url: "/client/user/save",
    method: "POST",
    mock: false,
  },
  {
    name: "UpdateClientUserStatus",
    url: "/client/user/status/update",
    method: "POST",
    mock: false,
  },
  {
    name: "UpdateIbUserStatus",
    url: "/ib/user/status/update",
    method: "POST",
    mock: false,
  },
  // 查看开户申请列表
  {
    name: "GetApplicationAccountList",
    url: "/application/account/list",
    method: "GET",
    mock: false,
  },
  // 查看开户申请详情
  {
    name: "GetApplicationAccountDetail",
    url: "/application/account/get",
    method: "GET",
    mock: false,
  },
  // 认领开户申请
  {
    name: "ClaimApplicationAccount",
    url: "/application/account/claim",
    method: "POST",
    mock: false,
  },
  // 审核开户申请
  {
    name: "AuditApplicationAccount",
    url: "/application/account/audit",
    method: "POST",
    mock: false,
  },
  // 查询交易服务器下组别 根据服务器id查询组别
  {
    name: "GetGroupByTradingServer",
    url: "/trading/account/get-groups",
    method: "GET",
    mock: false,
  },
  // 查询可用交易服务器列表
  {
    name: "GetAccountByTradingServer",
    url: "/trading/account/list-trading-server",
    method: "GET",
    mock: false,
  },
  {
    name: "GetAccountList",
    url: "/trading/account/list",
    method: "GET",
    mock: false,
  },
  // 查询交易账号详情
  {
    name: "GetAccountDetail",
    url: "/trading/account/get",
    method: "GET",
    mock: false,
  },
  // 交易账号MT4数据
  {
    name: "GetAccountLastUpdateTime",
    url: "/trading/account/get-last-update-time",
    method: "GET",
    mock: false,
  },
  // 更新交易账号MT4数据
  {
    name: "UpdateAccountData",
    url: "/trading/account/update-data",
    method: "POST",
    mock: false,
  },
  // 创建交易账号
  {
    name: "CreateAccount",
    url: "/trading/account/create",
    method: "POST",
    mock: false,
  },
  // 更新交易账号
  {
    name: "UpdateAccount",
    url: "/trading/account/update",
    method: "POST",
    mock: false,
  },
  // IB用户 创建交易账号
  {
    name: "IBCreateAccount",
    url: "/ib/rebate-account/create",
    method: "POST",
    mock: false,
  },
  //  IB用户 更新交易账号
  {
    name: "IBUpdateAccount",
    url: "/ib/rebate-account/update",
    method: "POST",
    mock: false,
  },
  // 检查交易账号是否合法
  {
    name: "GetAccountValidity",
    url: "/trading/account/get-validity",
    method: "GET",
    mock: false,
  },
  // 添加交易账号绑定用户
  {
    name: "CreateBindingUser",
    url: "/trading/account/create-binding-user",
    method: "POST",
    mock: false,
  },
  // 删除交易账号绑定用户
  {
    name: "DeleteBindingUser",
    url: "/trading/account/delete-binding-user",
    method: "POST",
    mock: false,
  },
  // 查询开户申请历史列表
  {
    name: "GetApplicationAccountHistoryList",
    url: "/application/account/list-history",
    method: "GET",
    mock: false,
  },
  // 查询开户申请详情
  {
    name: "GetApplicationAccountDetail",
    url: "/application/account/get",
    method: "GET",
    mock: false,
  },
  // 入金审核操作
  {
    name: "AuditApplicationDeposit",
    url: "/application/deposit/audit",
    method: "POST",
    mock: false,
  },
  // 认领入金审核
  {
    name: "ClaimApplicationDeposit",
    url: "/application/deposit/claim",
    method: "POST",
    mock: false,
  },
  // 入金审核详情
  {
    name: "GetApplicationDepositDetail",
    url: "/application/deposit/detail/get",
    method: "GET",
    mock: false,
  },
  // 入金审核列表
  {
    name: "GetApplicationDepositList",
    url: "/application/deposit/list",
    method: "GET",
    mock: false,
  },
  // 出金审核操作
  {
    name: "AuditApplicationWithdrawal",
    url: "/application/withdrawal/audit",
    method: "POST",
    mock: false,
  },
  // 认领出金审核
  {
    name: "ClaimApplicationWithdrawal",
    url: "/application/withdrawal/claim",
    method: "POST",
    mock: false,
  },
  // 出金审核详情
  {
    name: "GetApplicationWithdrawalDetail",
    url: "/application/withdrawal/detail/get",
    method: "GET",
    mock: false,
  },
  // 出金审核列表
  {
    name: "GetApplicationWithdrawalList",
    url: "/application/withdrawal/list",
    method: "GET",
    mock: false,
  },
  //入金审核历史
  {
    name: "GetApplicationAuditDepositHistoryList",
    url: "/application/deposit/history/list",
    method: "GET",
    mock: false,
  },
  //出金审核历史
  {
    name: "GetApplicationAuditWithdrawalHistoryList",
    url: "/application/withdrawal/history/list",
    method: "GET",
    mock: false,
  },
  // 获取杠杆审核列表
  {
    name: "GetLeverageList",
    url: "/application/leverage/list",
    method: "GET",
    mock: false,
  },
  // 获取杠杆审核详情
  {
    name: "GetLeverageDetail",
    url: "/application/leverage/get",
    method: "GET",
    mock: false,
  },
  // 查询杠杆更改申请历史列表
  {
    name: "GetApplicationLeverageHistoryList",
    url: "/application/leverage/list-history",
    method: "GET",
    mock: false,
  },
  // 审核杠杆
  {
    name: "AuditLeverage",
    url: "/application/leverage/audit",
    method: "POST",
    mock: false,
  },
  // 认领杠杆审核申请
  {
    name: "ClaimLeverage",
    url: "/application/leverage/claim",
    method: "POST",
    mock: false,
  },
  // 审核转账
  {
    name: "AuditTransfer",
    url: "/application/transfer/audit",
    method: "POST",
    mock: false,
  },
  // 认领转账审核申请
  {
    name: "ClaimTransfer",
    url: "/application/transfer/claim",
    method: "POST",
    mock: false,
  },
  // 查询转账审核列表
  {
    name: "GetTransferList",
    url: "/application/transfer/list",
    method: "GET",
    mock: false,
  },
  // 查询转账审核详情
  {
    name: "GetTransferDetail",
    url: "/application/transfer/get",
    method: "GET",
    mock: false,
  },
  // 查询转账审核历史列表
  {
    name: "GetApplicationTransferHistoryList",
    url: "/application/transfer/list-history",
    method: "GET",
    mock: false,
  },
  // 获取交易服务器下的交易品种
  {
    name: "GetTradingSymbolList",
    url: "/trading/symbol/list",
    method: "GET",
    mock: false,
  },

  // 代理层级相关接口--------------------------------------------------

  // 获取内置IB层级
  {
    name: "GetInternalIbLevel",
    url: "/setting/ib-level/get-internal",
    method: "GET",
    mock: false,
  },
  // 获取IB层级列表
  {
    name: "GetIbLevelList",
    url: "/setting/ib-level/list",
    method: "GET",
    mock: false,
  },
  //  创建IB层级
  {
    name: "CreateIbLevel",
    url: "/setting/ib-level/create",
    method: "POST",
    mock: false,
  },
  // 获取IB层级详情
  {
    name: "GetIbLevelDetail",
    url: "/setting/ib-level/get",
    method: "GET",
    mock: false,
  },
  //  更新IB层级
  {
    name: "UpdateIbLevel",
    url: "/setting/ib-level/update",
    method: "POST",
    mock: false,
  },
  //  删除IB层级
  {
    name: "DeleteIbLevel",
    url: "/setting/ib-level/delete",
    method: "POST",
    mock: false,
  },
  // 获取IB用户列表
  {
    name: "GetIbUserList",
    url: "/ib/user/list",
    method: "GET",
    mock: false,
  },
  //  创建IB用户
  {
    name: "CreateIbUser",
    url: "/ib/user/create",
    method: "POST",
    mock: false,
  },
  // 获取直属上级列表
  {
    name: "GetDirectSuperiorList",
    url: "/ib/get-direct-superiors",
    method: "GET",
    mock: false,
  },

  // 返佣规则相关接口------------------------------------------------------

  // 返佣-奖励参数创建
  {
    name: "CreateRebateParameterSetting",
    url: "/setting/rebate-parameter/create",
    method: "POST",
    mock: false,
  },
  // 返佣-奖励参数列表
  {
    name: "ListRebateParameterSetting",
    url: "/setting/rebate-parameter/list",
    method: "GET",
    mock: false,
  },
  // 返佣-奖励参数保存
  {
    name: "SaveRebateParameterSetting",
    url: "/setting/rebate-parameter/save",
    method: "POST",
    mock: false,
  },
  // 返佣规则创建
  {
    name: "CreateRebateSetting",
    url: "/setting/rebate/create",
    method: "POST",
    mock: false,
  },
  // 返佣规则删除
  {
    name: "DeleteRebateSetting",
    url: "/setting/rebate/delete",
    method: "POST",
    mock: false,
  },
  // 返佣规则获取
  {
    name: "GetRebateSetting",
    url: "/setting/rebate/get",
    method: "GET",
    mock: false,
  },
  // 返佣规则列表
  {
    name: "ListRebateSetting",
    url: "/setting/rebate/list",
    method: "GET",
    mock: false,
  },
  // 返佣规则修改
  {
    name: "UpdateRebateSetting",
    url: "/setting/rebate/update",
    method: "POST",
    mock: false,
  },

  // 品种组相关接口--------------------------------------------------

  // 品种组创建
  {
    name: "CreateSymbolGroupSetting",
    url: "/setting/symbol-group/create",
    method: "POST",
    mock: false,
  },
  // 品种组删除
  {
    name: "DeleteSymbolGroupSetting",
    url: "/setting/symbol-group/delete",
    method: "POST",
    mock: false,
  },
  // 品种组详情
  {
    name: "GetSymbolGroupSetting",
    url: "/setting/symbol-group/get",
    method: "GET",
    mock: false,
  },
  // 品种组列表（通用查看所有，编辑返佣规则时按照服务器过滤品种组）
  {
    name: "ListSymbolGroupSetting",
    url: "/setting/symbol-group/list",
    method: "GET",
    mock: false,
  },
  // 品种组修改
  {
    name: "UpdateSymbolGroupSetting",
    url: "/setting/symbol-group/update",
    method: "POST",
    mock: false,
  },

  // IB返佣设置相关接口--------------------------------------------------
  // 获取IB用户返佣设置列表
  {
    name: "GetIbRebateSettingList",
    url: "/ib/rebate-setting/list",
    method: "GET",
    mock: false,
  },
  //  创建IB用户返佣设置
  {
    name: "CreateIbRebateSetting",
    url: "/ib/rebate-setting/create",
    method: "POST",
    mock: false,
  },
  // 获取IB用户返佣设置详情
  {
    name: "GetIbRebateSettingDetail",
    url: "/ib/rebate-setting/get",
    method: "GET",
    mock: false,
  },
  //  更新IB用户返佣设置
  {
    name: "UpdateIbRebateSetting",
    url: "/ib/rebate-setting/update",
    method: "POST",
    mock: false,
  },
  //  更改IB用户返佣设置状态
  {
    name: "ChangeIbRebateSettingStatus",
    url: "/ib/rebate-setting/change-status",
    method: "POST",
    mock: false,
  },
  //  删除IB用户返佣设置
  {
    name: "DeleteIbRebateSetting",
    url: "/ib/rebate-setting/delete",
    method: "POST",
    mock: false,
  },

  //  获取出金报表
  {
    name: "GetBrokerWithdrawalReport",
    url: "/report/withdrawal/list",
    method: "GET",
    mock: false,
  },
  //  导出出金报表
  {
    name: "ExportBrokerWithdrawalReport",
    url: "/report/withdrawal/export",
    method: "POST",
    mock: false,
  },
  //  获取入金报表
  {
    name: "GetBrokerDepositReport",
    url: "/report/deposit/list",
    method: "GET",
    mock: false,
  },
  //  导出入金报表
  {
    name: "ExportBrokerDepositReport",
    url: "/report/deposit/export",
    method: "POST",
    mock: false,
  },
  // 角色权限相关接口
  //  创建CRM角色
  {
    name: "CreateCrmRole",
    url: "/crm/role/create",
    method: "POST",
    mock: false,
  },
  //  删除CRM角色
  {
    name: "DeleteCrmRole",
    url: "/crm/role/delete",
    method: "POST",
    mock: false,
  },
  //  获取所有的CRM角色详情
  {
    name: "GetCrmRole",
    url: "/crm/role/get",
    method: "GET",
    mock: false,
  },
  //  获取所有的CRM角色列表
  {
    name: "ListCrmRole",
    url: "/crm/role/list",
    method: "GET",
    mock: false,
  },
  //  编辑CRM角色
  {
    name: "SaveCrmRole",
    url: "/crm/role/save",
    method: "POST",
    mock: false,
  },

  //  获取转账报表
  {
    name: "GetBrokerTransferReport",
    url: "/report/transfer/list",
    method: "GET",
    mock: false,
  },
  //  导出转账报表
  {
    name: "ExportBrokerTransferReport",
    url: "/report/transfer/export",
    method: "POST",
    mock: false,
  },
  //  更改账户权限
  {
    name: "UpdateBrokerAccountPermission",
    url: "/trading/account/update-permission",
    method: "POST",
    mock: false,
  },
  //  获取持仓报表
  {
    name: "GetBrokerHoldingReport",
    url: "/report/holding/list",
    method: "GET",
    mock: false,
  },
  //  导出持仓报表
  {
    name: "ExportBrokerHoldingReport",
    url: "/report/holding/export",
    method: "POST",
    mock: false,
  },
  //  获取历史订单报表
  {
    name: "GetBrokerHistoryReport",
    url: "/report/history/list",
    method: "GET",
    mock: false,
  },
  //  导出历史订单报表
  {
    name: "ExportBrokerHistoryReport",
    url: "/report/history/export",
    method: "POST",
    mock: false,
  },
  //  佣金计算
  {
    name: "CalculateBrokerRebate",
    url: "/report/rebate/calculate",
    method: "POST",
    mock: false,
  },
  //  获取佣金报表
  {
    name: "GetBrokerRebateReport",
    url: "/report/rebate/list",
    method: "GET",
    mock: false,
  },
  // 发放佣金接口
  {
    name: "GrantBrokerRebate",
    url: "/report/rebate/grant",
    method: "POST",
    mock: false,
  },
  //  导出佣金报表
  {
    name: "ExportBrokerRebateReport",
    url: "/report/rebate/export",
    method: "POST",
    mock: false,
  },
  //  获取佣金明细报表
  {
    name: "GetBrokerRebateDetailReport",
    url: "/report/rebate-detail/list",
    method: "GET",
    mock: false,
  },
  //  导出佣金明细报表
  {
    name: "ExportBrokerRebateDetailReport",
    url: "/report/rebate-detail/export",
    method: "POST",
    mock: false,
  },
  //  获取CRM用户列表
  {
    name: "GetBrokerCrmUserList",
    url: "/crm/user/list",
    method: "GET",
    mock: false,
  },
  //  获取CRM用户详情
  {
    name: "GetBrokerCrmUserDetail",
    url: "/crm/user/get",
    method: "GET",
    mock: false,
  },
  //  创建CRM用户
  {
    name: "CreateBrokerCrmUser",
    url: "/crm/user/create",
    method: "POST",
    mock: false,
  },
  // 编辑CRM角色
  {
    name: "SaveBrokerCrmUser",
    url: "/crm/user/save",
    method: "POST",
    mock: false,
  },
  // 获取所有的CRM角色列表
  {
    name: "GetAllCrmRole",
    url: "/crm/role/all",
    method: "GET",
    mock: false,
  },
  // 编辑CRM用户状态
  {
    name: "UpdateBrokerCrmUserStatus",
    url: "/crm/user/status",
    method: "POST",
    mock: false,
  },
  // 修改返佣发放模式相关接口
  // 获取返佣发放模式
  {
    name: "GetRebateAutoMode",
    url: "/setting/rebate-auto-mode/get",
    method: "GET",
    mock: false,
  },
  // 设置返佣发放模式
  {
    name: "SaveRebateAutoMode",
    url: "/setting/rebate-auto-mode/save",
    method: "POST",
    mock: false,
  },
  //查询可用交易账号类型列表
  {
    name: "GetBrokerAvailableTradingAccountTypeOptions",
    url: "/trading/account/get-type-options",
    method: "GET",
    mock: false,
  },
  //查询用于筛选创建交易账户选用账户类型的可用交易服务器列表
  {
    name: "GetBrokerAvailableTradingServerList",
    url: "/trading/account/list-available-server",
    method: "GET",
    mock: false,
  },
  //获取审核拒绝原因
  {
    name: "GetAuditRemark",
    url: "/application/audit/remark/list",
    method: "GET",
    mock: false,
  },
  // 管理员免密登录Client用户
  {
    name: "ClientUserPasswordlessLogin",
    url: "/client/user/passwordless-login",
    method: "POST",
    mock: false,
  },
  // 管理员免密登录Ib用户
  {
    name: "IbUserPasswordlessLogin",
    url: "/ib/user/passwordless-login",
    method: "POST",
    mock: false,
  },
  // 管理员免密登录客户
  {
    name: "CustomerPasswordlessLogin",
    url: "/customer/passwordless-login",
    method: "POST",
    mock: false,
  },
  // 客户模块相关接口
  // 客户列表
  {
    name: "ListCustomerForBroker",
    url: "/customer/list",
    method: "GET",
    mock: false,
  },
  // 获取客户详情
  {
    name: "GetCustomerForBroker",
    url: "/customer/get",
    method: "GET",
    mock: false,
  },
  // 保存客户信息
  {
    name: "SaveCustomerForBroker",
    url: "/customer/save",
    method: "POST",
    mock: false,
  },
  // 修改客户状态
  {
    name: "UpdateCustomerStatus",
    url: "/customer/status/update",
    method: "POST",
    mock: false,
  },
  // 创建客户
  {
    name: "CreateCustomerForBroker",
    url: "/customer/create",
    method: "POST",
    mock: false,
  },

  // Client端,IB端权限相关接口
  // 获取所有菜单和按钮权限
  {
    name: "GetAllPermission",
    url: "/user/menu/list",
    method: "GET",
    mock: false,
  },
  // 获取用户选中的权限
  {
    name: "GetPermissionUseSelect",
    url: "/user/permissions",
    method: "GET",
    mock: false,
  },
  // 给Client IB用户分配权限
  {
    name: "ClientIbPermissionAssign",
    url: "/user/permissions/assign",
    method: "POST",
    mock: false,
  },

  // 批量更新交易账号
  {
    name: "BatchUpdateAccounts",
    url: "/trading/account/batch-update",
    method: "POST",
    mock: false,
  },
  // 代理关系树-搜索IB用户
  {
    name: "SearchAgentByEmail",
    url: "/ib/user/search-by-email",
    method: "GET",
    mock: false,
  },
  // 代理关系树-获取关系树数据
  {
    name: "GetAgentTree",
    url: "/ib/user/agent-tree",
    method: "GET",
    mock: false,
  },
  // 查询IB代理层级树
  {
    name: "GetIbTree",
    url: "/ib/tree",
    method: "GET",
    mock: false,
  },
  // 后台查询交易品种下拉选项
  {
    name: "GetSymbolList",
    url: "/report/symbol/list",
    method: "GET",
    mock: false,
  },
  // 后台查询挂单报表
  {
    name: "GetPendingList",
    url: "/report/pending/list",
    method: "GET",
    mock: false,
  },
  // 后台导出挂单报表
  {
    name: "ExportPendingList",
    url: "/report/pending/export",
    method: "POST",
    mock: false,
  },
  // 返佣-GMT时区列表
  {
    name: "GetGMTTimezoneList",
    url: "/setting/gmt-timezone/list",
    method: "GET",
    mock: false,
  },
  // 返佣-时区设置获取
  {
    name: "GetRebateTimezone",
    url: "/setting/rebate-timezone/get",
    method: "GET",
    mock: false,
  },
  // 返佣-时区设置保存
  {
    name: "SaveRebateTimezone",
    url: "/setting/rebate-timezone/save",
    method: "POST",
    mock: false,
  },
  // 创建弹窗配置
  {
    name: "CreatePopup",
    url: "/operation/popup/create",
    method: "POST",
    mock: false,
  },
  // 删除弹窗配置
  {
    name: "DeletePopup",
    url: "/operation/popup/delete",
    method: "POST",
    mock: false,
  },
  // 获取弹窗配置详情
  {
    name: "GetPopupDetail",
    url: "/operation/popup/get",
    method: "GET",
    mock: false,
  },
  // 更新弹窗配置
  {
    name: "UpdatePopup",
    url: "/operation/popup/update",
    method: "POST",
    mock: false,
  },
  // 获取弹窗配置列表
  {
    name: "GetPopupList",
    url: "/operation/popup/list",
    method: "GET",
    mock: false,
  },
  // 更新弹窗配置状态
  {
    name: "UpdatePopupStatus",
    url: "/operation/popup/status/update",
    method: "POST",
    mock: false,
  },
  // 运营管理-投放配置
  // 新增投放配置
  {
    name: "CreateDeliveryConfig",
    url: "/operation/delivery/create",
    method: "POST",
    mock: false,
  },
  // 删除投放配置
  {
    name: "DeleteDeliveryConfig",
    url: "/operation/delivery/delete",
    method: "POST",
    mock: false,
  },
  // 获取投放配置详情
  {
    name: "GetDeliveryConfig",
    url: "/operation/delivery/get",
    method: "GET",
    mock: false,
  },
  // 获取投放配置列表
  {
    name: "ListDeliveryConfig",
    url: "/operation/delivery/list",
    method: "GET",
    mock: false,
  },
  // 更新投放配置
  {
    name: "UpdateDeliveryConfig",
    url: "/operation/delivery/update",
    method: "POST",
    mock: false,
  },
  // 更改投放配置状态
  {
    name: "UpdateDeliveryConfigStatus",
    url: "/operation/delivery/update-status",
    method: "POST",
    mock: false,
  },
  // 预览弹窗
  {
    name: "PreviewPopup",
    url: "/operation/popup/preview",
    method: "GET",
    mock: false,
  },
  // 后台获取交易服务器选项列表
  {
    name: "GetReportServerList",
    url: "/report/server/list",
    method: "GET",
    mock: false,
  },
  // 获取Dashboard最后更新时间
  {
    name: "GetDashboardUpdateTime",
    url: "/dashboard/get-last-update-time",
    method: "GET",
    mock: false,
  },
  // Admin端-dashboard汇总接口
  {
    name: "GetAdminDashboardSummary",
    url: "/dashboard",
    method: "GET",
    mock: false,
  },
  // 保存用户卡片偏好
  {
    name: "SaveUserPreference",
    url: "/dashboard/preference",
    method: "POST",
    mock: false,
  },
  // Admin端-获取用户可用的卡片列表
  {
    name: "GetAvailableCards",
    url: "/dashboard/available-cards",
    method: "GET",
    mock: false,
  },
  // Admin端-获取所有交易品种选项
  {
    name: "GetTradingSymbolsList",
    url: "/dashboard/trading-symbols/list",
    method: "GET",
    mock: false,
  },
  // 交易工具子栏目配置-创建
  {
    name: "CreateTradingToolColumn",
    url: "/trading-tool/column/create",
    method: "POST",
    mock: false,
  },
  // 交易工具子栏目配置-更新
  {
    name: "UpdateTradingToolColumn",
    url: "/trading-tool/column/update",
    method: "POST",
    mock: false,
  },
  // 交易工具子栏目配置-删除
  {
    name: "DeleteTradingToolColumn",
    url: "/trading-tool/column/delete",
    method: "POST",
    mock: false,
  },
  // 交易工具子栏目配置-列表
  {
    name: "GetTradingToolColumnList",
    url: "/trading-tool/column/list",
    method: "GET",
    mock: false,
  },
  // 交易工具子栏目配置-详情
  {
    name: "GetTradingToolColumnDetail",
    url: "/trading-tool/column/get",
    method: "GET",
    mock: false,
  },
  // 交易工具子栏目配置-更新状态
  {
    name: "UpdateTradingToolColumnStatus",
    url: "/trading-tool/column/update-status",
    method: "POST",
    mock: false,
  },
  // 点值规则-创建
  {
    name: "SettingCreatePointRule",
    url: "/setting/point-rule/create",
    method: "POST",
    mock: false,
  },
  // 点值规则-删除
  {
    name: "SettingDeletePointRule",
    url: "/setting/point-rule/delete",
    method: "POST",
    mock: false,
  },
  // 点值规则-列表
  {
    name: "SettingListPointRule",
    url: "/setting/point-rule/list",
    method: "GET",
    mock: false,
  },
  // 点值规则-更新
  {
    name: "SettingUpdatePointRule",
    url: "/setting/point-rule/update",
    method: "POST",
    mock: false,
  },
  // 消息-创建
  {
    name: "CreateMessage",
    url: "/message/create",
    method: "POST",
    mock: false,
  },
  // 消息-删除
  {
    name: "DeleteMessage",
    url: "/message/delete",
    method: "POST",
    mock: false,
  },
  // 消息-列表
  {
    name: "ListMessage",
    url: "/message/list",
    method: "GET",
    mock: false,
  },
  // 消息-详情
  {
    name: "GetMessage",
    url: "/message/get",
    method: "GET",
    mock: false,
  },
  // 消息-搜索用户
  {
    name: "SearchMessageUser",
    url: "/message/search-user",
    method: "GET",
    mock: false,
  },
  // 消息-发件人列表
  {
    name: "ListMessageSenders",
    url: "/message/senders",
    method: "GET",
    mock: false,
  },
  // 日志相关接口
  //查询验证码记录列表
  {
    name: "ListEmailVerificationLog",
    url: "/log/email-verification/list",
    method: "GET",
    mock: false,
  },
  //查询操作日志列表
  {
    name: "ListOperationLog",
    url: "/log/operation/list",
    method: "GET",
    mock: false,
  },
  //查询操作人列表
  {
    name: "ListOperator",
    url: "/log/operator/list",
    method: "GET",
    mock: false,
  },

  // 查询问卷结果
  {
    name: "GetQuestionnaireResult",
    url: "/questionnaire/get-result",
    method: "GET",
    mock: false,
  },

  // 获取当前租户可用电子认证服务列表
  {
    name: "GetEVerifyServiceList",
    url: "/e-verify-service/list",
    method: "GET",
    mock: false,
  },

  // 获取电子认证服务配置详情
  {
    name: "GetEVerifyServiceDetail",
    url: "/e-verify-service/get",
    method: "GET",
    mock: false,
  },

  // 保存电子认证服务配置
  {
    name: "SaveEVerifyService",
    url: "/e-verify-service/save",
    method: "POST",
    mock: false,
  },

  // 获取当前租户可用电子认证服务下拉列表选项
  {
    name: "GetEVerifyServiceOptions",
    url: "/e-verify-service/list-options",
    method: "GET",
    mock: false,
  },

  // 切换电子认证服务启用状态
  {
    name: "ToggleEVerifyServiceStatus",
    url: "/e-verify-service/toggle-status",
    method: "POST",
    mock: false,
  },
  // 修改管理员登录密码
  {
    name: "UpdateLoginPassword",
    url: "/login-password/update",
    method: "POST",
    mock: false,
  },
];
